module.exports = __webpack_public_path__ + "static/media/nicaragua-map-on.97af138b.png";